import './square-grid.scss';

const selectors: Record<'container' | 'list' | 'group' | 'button', string> = {
  container: '[data-square-grid]',
  list: '[data-square-grid-list]',
  group: '[data-square-grid-group]',
  button: '[data-square-grid-button]',
};

const classes: Record<'active', string> = {
  active: 'active',
};

const elements: Record<
  'container' | 'list' | 'groups' | 'buttons',
  null | HTMLElement | NodeListOf<HTMLElement>
> = {
  container: null,
  list: null,
  groups: null,
  buttons: null,
};

function setMaxHeightBlock() {
  // @ts-ignore
  if (elements.groups && elements.groups.length > 1) {
    // @ts-ignore
    const height = elements.groups[0].getBoundingClientRect().height + 125;
    // @ts-ignore
    elements.list.style.height = height + 'px';
  }
}

function init() {
  elements.container = document.querySelector(
    selectors.container
  ) as HTMLElement;
  elements.list = document.querySelector(selectors.list) as HTMLElement;
  elements.groups = document.querySelectorAll(selectors.group);
  elements.buttons = document.querySelectorAll(selectors.button);

  if (!elements.container || !elements.groups.length) return null;

  setMaxHeightBlock();
  addEventListener('resize', setMaxHeightBlock);

  if (!elements.buttons.length) return null;
  Array.from(elements.buttons).map((el) =>
    el.addEventListener('click', () => {
      // @ts-ignore
      elements.list.classList.toggle(classes.active);
    })
  );
}

document.addEventListener(
  'DOMContentLoaded',
  async function () {
    init();
  },
  {
    once: true,
  }
);
